module.exports = __webpack_public_path__ + "static/media/height.fdf6e353.svg";